var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var RelationItem = Marionette.View.extend({
    tagName: 'li',
    template: require('../../templates/relations/relation-item.html'),
    events:{
        'click .remove-relation': 'removeRelation'
    },

    initialize: function(){
        _.bindAll(this, 'removeRelation');
    },

    removeRelation: function(event){
        this.model.destroy();
    }
});

var RelationsListView = Marionette.CollectionView.extend({
    tagName: 'ul',
    childView: RelationItem,

    initialize: function() {
    }
});

module.exports = RelationsListView;


//////////////////
// WEBPACK FOOTER
// ./app/views/relations/relations-list-view.js
// module id = 234
// module chunks = 0